import React from "react";
import { Heart, Mountain, Users, Leaf } from "lucide-react";
import { IMAGES } from "../../lib/constants";
import { PageHero, SectionHeading, FeatureGrid, CtaBand } from "../../components/marketing/Blocks";

export default function About() {
  return (
    <>
      <PageHero
        eyebrow="About us"
        title="A mobility company built for every Indian city."
        lead="KohimaTaxi & Delivery brings rides and food delivery together in one reliable app — upfront fares, verified partners and live tracking, for busy metros and growing towns alike."
        image={IMAGES.hillTown}
        imageAlt="Gourmet food delivery spread"
      />
      <section className="kt-container py-16 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-2">
          <div>
            <SectionHeading eyebrow="Our story" title="One app for rides and food, across India." />
            <div className="mt-6 space-y-4 text-base leading-relaxed text-ink-soft">
              <p>We began with a simple idea: customers want a fair, upfront fare; drivers want steady work without a middleman taking half; and restaurants want a way to reach homes beyond walking distance.</p>
              <p>Today the same idea runs on a proper platform: verified drivers and restaurants, upfront pricing, live tracking, in-app chat and a shared account that works on mobile and this website.</p>
              <p>We are a lean, customer-obsessed team. Fair pricing for riders, honest earnings for partners, and a smooth experience on both mobile and this website.</p>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <img src={IMAGES.mistyHills} alt="Modern taxi cab on city street" className="aspect-[3/4] w-full rounded-3xl object-cover" loading="lazy" />
            <img src={IMAGES.receivingDelivery} alt="Delivery agent in uniform" className="mt-8 aspect-[3/4] w-full rounded-3xl object-cover" loading="lazy" />
          </div>
        </div>
      </section>
      <section className="bg-surface-200/60 py-16 lg:py-24">
        <div className="kt-container">
          <SectionHeading eyebrow="What we stand for" title="Our values" align="center" />
          <div className="mt-12">
            <FeatureGrid columns={4} items={[
              { icon: Mountain, title: "Rider first", text: "Built around real journeys — clear fares and no surprises, every trip." },
              { icon: Users, title: "Fair to partners", text: "Drivers and restaurants keep what they earn. Transparent, always." },
              { icon: Heart, title: "Safety, not slogans", text: "Document verification before anyone goes live. No exceptions." },
              { icon: Leaf, title: "Light footprint", text: "Scooters and bikes for short hops, pooling routes where it makes sense." },
            ]} />
          </div>
        </div>
      </section>
      <CtaBand title="Come build this with us." text="Whether you ride, drive or cook, there is a place for you on the platform." cta={{ to: "/auth/signup", label: "Join KohimaTaxi" }} />
    </>
  );
}
